import React from 'react';
import { useLocation } from 'react-router-dom';
import ResetPasswordForm from '../../components/ResetPasswordForm';

export const ResetPassword: React.FC = () => {
  const location = useLocation();

  // Extract the query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token'); // Example: ?token=12345
  const email = queryParams.get('email'); 

  return (
    <ResetPasswordForm token={token} email={email} />
  );
};

export default ResetPassword;